export function formatDuration(duration: number) {
  const minutes = Math.floor(duration / 60)
  const seconds = Math.floor(duration % 60)

  const secondsFormat = new Intl.NumberFormat('nl', {
    maximumFractionDigits: 0,
    minimumIntegerDigits:  2,
  })
  return `${minutes}:${secondsFormat.format(seconds)}`
}